export default "__VITE_ASSET__DZnKFubN__"